<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <div class="detail-item">
      <div class="detail-item-left">适用组织：</div>
      <div class="detail-item-right">{{ detailInfo.deptName }}</div>
    </div>
    <div class="detail-item">
      <div class="detail-item-left">管理主体：</div>
      <div class="detail-item-right">{{ detailInfo.leadTypeName }}</div>
    </div>
    <div class="detail-item">
      <div class="detail-item-left">考核指标：</div>
      <div class="detail-item-right">{{ detailInfo.codeTypeName }}</div>
    </div>
    <div class="detail-item">
      <div class="detail-item-left">达标要求：</div>
      <div class="detail-item-right">
        <div class="code-mark">
          <span>绿码要求：</span>
          <span>不符合黄码和红码要求，均为绿码</span>
        </div>
        <div class="code-mark">
          <span>黄码要求：</span>
          <span
            >x &lt;{{ detailInfo.yellowLimit }} ，<i class="gray-char"
              >其中x为{{ detailInfo.codeTypeName }}</i
            ></span
          >
        </div>
        <div class="code-mark">
          <span>红码要求：</span>
          <span
            >x &lt;{{ detailInfo.redLimit }} ，<i class="gray-char"
              >其中x为{{ detailInfo.codeTypeName }}</i
            ></span
          >
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click="closeDialog" title="关闭"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    detailInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-item {
  display: flex;
  line-height: 30px;
}
.detail-item-left {
  width: 100px;
  text-align: right;
}
.detail-item-right {
  width: calc(100% - 120px);
}
.gray-char {
  color: #b4b4b4;
}
</style>
